/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_TitleInputs */

const vi_sales_return_title = /** @type {(inputs: Sales_Return_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả hàng`)
};

/**

* @param {Sales_Return_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_title = /** @type {((inputs?: Sales_Return_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_title(inputs)
});